import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const WhispersofWisdom2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/16.webp`;
const p17 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/17.webp`;
const p18 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/18.webp`;
const p19 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/19.webp`;
const p20 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/20.webp`;
const p21 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/21.webp`;
const p22 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/22.webp`;
const p23 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/23.webp`;
const p24 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/24.webp`;
const p25 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/25.webp`;
const p26 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/26.webp`;
const p27 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/27.webp`;
const p28 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/28.webp`;
const p29 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/29.webp`;
const p30 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/30.webp`;
const p31 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/31.webp`;
const p32 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/32.webp`;
const p33 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/33.webp`;
const p34 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/34.webp`;
const p35 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/35.webp`;
const p36 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/36.webp`;
const p37 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/37.webp`;
const p38 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/38.webp`;
const p39 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/39.webp`;
const p40 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/40.webp`;
const p41 = `${config.base_image_url_2025}/home/events-activities/pre-primary/WOW/41.webp`;


 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
},
{
    src: p18,
    source: p18,
    rows: 1,
    cols: 1,
},
{
    src: p19,
    source: p19,
    rows: 1,
    cols: 1,
},
{
    src: p20,
    source: p20,
    rows: 1,
    cols: 1,
},
{
    src: p21,
    source: p21,
    rows: 1,
    cols: 1,
},
{
    src: p22,
    source: p22,
    rows: 1,
    cols: 1,
},
{
    src: p23,
    source: p23,
    rows: 1,
    cols: 1,
},
{
    src: p24,
    source: p24,
    rows: 1,
    cols: 1,
},
{
    src: p25,
    source: p25,
    rows: 1,
    cols: 1,
},
{
    src: p26,
    source: p26,
    rows: 1,
    cols: 1,
},
{
    src: p27,
    source: p27,
    rows: 1,
    cols: 1,
},
{
    src: p28,
    source: p28,
    rows: 1,
    cols: 1,
},
{
    src: p29,
    source: p29,
    rows: 1,
    cols: 1,
},
{
    src: p30,
    source: p30,
    rows: 1,
    cols: 1,
},
{
    src: p31,
    source: p31,
    rows: 1,
    cols: 1,
},
{
    src: p32,
    source: p32,
    rows: 1,
    cols: 1,
},
{
    src: p33,
    source: p33,
    rows: 1,
    cols: 1,
},
{
    src: p34,
    source: p34,
    rows: 1,
    cols: 1,
},
{
    src: p35,
    source: p35,
    rows: 1,
    cols: 1,
},
{
    src: p36,
    source: p36,
    rows: 1,
    cols: 1,
},
{
    src: p37,
    source: p37,
    rows: 1,
    cols: 1,
},
{
    src: p38,
    source: p38,
    rows: 1,
    cols: 1,
},
{
    src: p39,
    source: p39,
    rows: 1,
    cols: 1,
},
{
    src: p40,
    source: p40,
    rows: 1,
    cols: 1,
},
{
    src: p41,
    source: p41,
    rows: 1,
    cols: 1,
}

  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      WOW - Whispers of Wisdom
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: PRE-PRIMARY Date: 31 October 2025  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “WOW - Whispers of Wisdom Grandparents’ Day Celebration – A Day to Cherish, a Bond to Treasure”
   <br/><br/>
Grandparents are the footsteps to the future generations.
<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The school ground came alive with joy, laughter and love as our Pre-Primary Department celebrated its much-awaited Annual Event – “WOW: Whispers of Wisdom” on Friday, 31 October 2025 — a special day dedicated to honouring the beautiful bond between grandparents, grand children and parents.
       <br></br>
        This celebration was held outdoors, transforming the campus into a vibrant carnival of joy. Colourful stalls, playful zones and cheerful decorations created a heart-warming atmosphere where families came together to celebrate love across generations.
        <br></br>
        The event was graced by our Director, Dr. Manjula Shivshankar Ma’am and our Principal Ms Sheeja Manoj Ma’am, whose motivational speeches inspired everyone to cherish family bonds and continue nurturing the values passed down through generations. Their words beautifully echoed the theme — that grandparents are not just our roots but also our guiding lights.
       <br></br>
       <br></br>
        <strong>A Celebration of Togetherness</strong>
        <br></br>
        The event welcomed children, dressed in bright event T-shirts, along with their parents and grandparents. The air was abuzz with excitement as families explored the many game stalls, ball pool, art corners, and creative activity zones designed especially for young learners.
        The highlight of the day was the grand stage performances, where grandparents and children came together to showcase their talents. From soulful songs and lively dances to heart-touching skits and inspirational information each performance symbolised patience and love.
        <br></br>
        <br></br>
        <strong>Flavours, Fun, and Fond Memories</strong>
        <br></br>
        Adding to the festive spirit, refreshments were served to the children, while families enjoyed delicious treats from the food trucks set up around the venue. From giggles over ice creams to conversations under the open sky, every moment celebrated the essence of family and togetherness.
        Children were also thrilled to receive special hamper bags filled with delightful goodies — popcorn, biscuits, cakes, puzzles, play springs, lacing boards, colourful headgears, and balloon art creations — adding an extra sparkle to their day. The excitement of opening these hampers mirrored the joy of the celebration itself — full of surprises, smiles, and shared happiness.
        <br></br>
        As the day came to a close, hearts were full and smiles brighter. “WOW – Whispers of Wisdom” was more than just a Grandparents’ Day celebration — it was a tribute to love that spans generations, a reminder that wisdom often comes wrapped in warmth, and that childhood shines brightest when shared with family.
        <br></br>
        <br></br>
        <strong>Grandparents may be old in years, but forever young in love.</strong>
        <br></br>
        They are the soft hands that guide, the warm hearts that nurture, and the gentle voices that whisper wisdom into our lives. 
        <br></br>
        The event concluded with every Grandparent feeling valued, every child feeling loved, and every family carrying home cherished memories — of a bond that continues to glow through time.
        <br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Learning shines brightest when wrapped in celebration.”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default WhispersofWisdom2025;